import { delay } from "@rauricoste/core";
import {
  EventSyncInterface,
  TransportEvent,
  TransportEventSent,
} from "../../export";

export class EventSyncLocalStorageAdapter<Event>
  implements EventSyncInterface<Event>
{
  constructor(
    public readonly simulatedLagInMs = 500,
    public readonly key: string = "undefined"
  ) {}

  private get localStorageKey(): string {
    return `OptimisticInMemoryAdapter.${this.key}`;
  }

  async delete(): Promise<void> {
    await delay(this.simulatedLagInMs);
    localStorage.removeItem(this.localStorageKey);
  }

  get transportEvents(): TransportEvent<Event>[] {
    const valueStr = localStorage.getItem(this.localStorageKey);
    if (!valueStr) {
      return [];
    }
    return JSON.parse(valueStr) as TransportEvent<Event>[];
  }

  async getNewEventsFrom(timestamp: number): Promise<TransportEvent<Event>[]> {
    await delay(this.simulatedLagInMs);
    return this.transportEvents.filter((event) => event.timestamp > timestamp);
  }
  async sendEvents(events: TransportEventSent<Event>[]): Promise<void> {
    await delay(this.simulatedLagInMs);
    let { transportEvents } = this;
    transportEvents = transportEvents.concat(
      events.map((event, index) => ({
        ...event,
        timestamp: new Date().getTime() + index,
      }))
    );
    localStorage.setItem(this.localStorageKey, JSON.stringify(transportEvents));
  }
}
